import { ROUTES } from '../routes'

/** Adresse publique de la page d'un producteur (celle que l'on partage). */
export const urlPageProducteur = (id) => `${window.location.origin}${ROUTES.producteurPublic.vers(id)}`

/**
 * La feuille de partage native n'a de sens que sur ecran tactile : sur un
 * ordinateur (Safari macOS notamment) elle ouvre un menu systeme deroutant
 * (AirDrop, Notes, Rappels...). Ailleurs on copie simplement le lien.
 */
const feuilleNativeDisponible = () =>
  typeof navigator.share === 'function' && window.matchMedia?.('(pointer: coarse)').matches

/**
 * Partager la page d'un producteur (S62).
 * Feuille de partage native sur mobile / tablette, sinon copie du lien.
 * @returns {Promise<'partage'|'copie'|'annule'|'echec'>}
 */
export async function partagerProducteur({ id, nom, description }) {
  const url = urlPageProducteur(id)
  const texte = description ? description.slice(0, 140) : `Découvrez ${nom} sur Lyannaj`
  if (feuilleNativeDisponible()) {
    try {
      await navigator.share({ title: `${nom} · Lyannaj`, text: texte, url })
      return 'partage'
    } catch (e) {
      if (e?.name === 'AbortError') return 'annule'
      // certains navigateurs refusent le partage hors geste : on retombe sur la copie
    }
  }
  try {
    await navigator.clipboard.writeText(url)
    return 'copie'
  } catch {
    return 'echec'
  }
}

/**
 * Partager une IMAGE (le visuel a poster, S64).
 * Sur ecran tactile : feuille native avec le fichier, ce qui ouvre directement
 * Instagram, WhatsApp... Ailleurs : telechargement du PNG.
 * Sur iOS sans partage de fichiers, on ouvre l'image dans un onglet : un appui
 * long permet de l'enregistrer dans la pellicule.
 * @returns {Promise<'partage'|'telecharge'|'ouvert'|'annule'|'echec'>}
 */
export async function partagerImage({ url, nomFichier = 'lyannaj.png', titre = 'Lyannaj' }) {
  let blob
  try {
    const r = await fetch(url)
    if (!r.ok) return 'echec'
    blob = await r.blob()
  } catch {
    return 'echec'
  }
  const fichier = new File([blob], nomFichier, { type: 'image/png' })
  const tactile = window.matchMedia?.('(pointer: coarse)').matches
  if (tactile && navigator.canShare?.({ files: [fichier] })) {
    try {
      await navigator.share({ files: [fichier], title: titre })
      return 'partage'
    } catch (e) {
      if (e?.name === 'AbortError') return 'annule'
    }
  }
  const lien = URL.createObjectURL(blob)
  const iOS = /iP(hone|ad|od)/.test(navigator.userAgent)
  if (iOS) {
    window.open(lien, '_blank')
    return 'ouvert'
  }
  const a = document.createElement('a')
  a.href = lien
  a.download = nomFichier
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(lien), 10_000)
  return 'telecharge'
}
